import(/* webpackMode: "eager" */ "/var/www/vhosts/castly.nl/httpdocs/src/app/(auth)/register/page.tsx");
